import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import queryString from 'query-string';
import { useParams } from 'react-router';
import CatalogTriggerForm from '../../components/CatalogTriggers/CatalogTriggerForm';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['catalogTrigger']}`;

const CatalogTriggersNewPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const [catalogTrigger, setCatalogTrigger] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    const query = queryString.parse(location.search);

    if (query.from) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/catalogTriggers/${query.from}`)
        .then(({ catalogTrigger }) => {
          catalogTrigger.name = `Copy of ${catalogTrigger.name}`;
          delete catalogTrigger.id;
          setCatalogTrigger(catalogTrigger);
        })
        .catch(setLoadError);
    } else {
      setCatalogTrigger({
        name: 'New catalog trigger',
        catalogRules: [],
        audienceRules: [],
      });
    }
  }, [accountId, domainId, fetch, location.search]);

  const create = (catalogTrigger) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/catalogTriggers`, {
      method: 'POST',
      body: JSON.stringify(catalogTrigger),
    })
      .then(() => {
        navigate(location.pathname.replace(`/catalogTriggers/new`, '/catalogTriggers'));
      })
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!catalogTrigger) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/catalogTriggers` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <CatalogTriggerForm
              catalogTrigger={catalogTrigger}
              saveCatalogTrigger={(catalogTrigger) => create(catalogTrigger)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default CatalogTriggersNewPage;
